export const state = () => ({
  loading: false
})
export const getters = {}
export const mutations = {}
export const actions = {
  checkFileExists(a, { path }) {
    return this.$axios.post('/api/file/exists', { path: path })
  }
}
